import { Numeric3CircleIcon } from './Numeric3CircleIcon';

/**
 * author: Contributors
 * id 07FDE137-E119-45E9-8100-3C0194FFF51D
 * name numeric-3-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-3-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericThreeCircleIcon = Numeric3CircleIcon;
export default NumericThreeCircleIcon